module.exports = __webpack_public_path__ + "static/img/bg.bad7eec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg.png
// module id = TVrh
// module chunks = 1